import { useState } from 'react';


const ToasterModal = ({ message, show, type, onClose }) => {
    if (!show) return null;
const isSuccess = type === 'success';

    return (
        <>
            <div className="modal show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog">
                    <div className="modal-content p-4">

                        <div className="error-message-box mt-3 mb-3" style={{ borderColor: isSuccess ? '#28a745' : '#D14343' }}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                {isSuccess ? (
                                    <path fillRule="evenodd" clipRule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" fill="#28a745" />
                                ) : (
                                    <path fillRule="evenodd" clipRule="evenodd" d="M7.99989 0.00488281C3.58265 0.00488281 0.00488281 3.58265 0.00488281 7.99989C0.00488281 12.4171 3.58265 15.9949 7.99989 15.9949C12.4171 15.9949 15.9949 12.4171 15.9949 7.99989C15.9949 3.58265 12.4171 0.00488281 7.99989 0.00488281ZM7.00051 12.9968V10.998H8.99926V12.9968H7.00051ZM7.00051 3.00301V9.99864H8.99926V3.00301H7.00051Z" fill="#D14343" />
                                )}
                            </svg>
                            <div className="error-message-holder">
                                <p className="error-message text-start" style={{ color: isSuccess ? '#28a745' : '#D14343' }}>{isSuccess ? 'Success' : 'Error'}</p>
                                <p className="error-message-text">{message}</p>
                            </div>
                        </div>
                        <div className="d-flex justify-content-end">
                            <button className="btn btn-primary btn-small" onClick={onClose}>Continue</button>
                        </div>
                    </div>
                </div>
            </div>
    </>
    );
};

export default ToasterModal;
